export const NotificationTypes = {
  Deal: 'deal',
  Event: 'event',
  Job: 'job',
  News: 'news',
};
